import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Media from '../Components/Media/Media';

const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  background: '#f8f9fa',
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 4),
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: 'white',
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(70, 80, 100, 0.1)',
  overflow: 'hidden',
  padding: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4),
  },
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  background: '#465064',
  color: 'white',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.spacing(2),
  textAlign: 'center',
}));

const Other = () => {
  return (
    <StyledContainer maxWidth="lg">
      <StyledPaper elevation={0}>
        <HeaderBox>
          <Typography variant="h3" sx={{ 
            fontWeight: 600, 
            mb: 1,
            fontSize: { xs: '1.8rem', md: '2.2rem' }
          }}>
            ⚙️ Additional Services
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.8, fontWeight: 400 }}>
            Explore our comprehensive range of services
          </Typography>
        </HeaderBox>

        <Box sx={{ 
          background: '#f8f9fa',
          borderRadius: 2,
          p: 3,
          border: '1px solid #e9ecef',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            background: '#465064',
          }
        }}>
          <Media showQRCode={false} view={true} />
        </Box>
      </StyledPaper>
    </StyledContainer>
  );
};

export default Other; 